import { ParentMenuProps } from '@toasttab/shared/src/data/HeaderNavigation/MainNavigationMenu.d'

const Retail: ParentMenuProps = {
  label: 'Retail',
  description: 'Seamless customer experiences for your retail needs',
  heapClass: 'topnav_retail_v',
  showcaseMobile: true,
  showcaseEntries: [
    {
      title: 'Retail POS System',
      description:
        'Create a seamless customer experience for your retail needs',
      heapClass: 'nav_retailpos_v',
      thumbnail:
        'https://images.ctfassets.net/tgv5pu8pgmos/2xrT0yDBmAx9O2aDWKXF55/9836811457f66d029ff6e95149b242e5/img-toast-restaurant-retail.png',
      badge: {
        label: 'Featured',
        color: 'bg-yellow-25'
      },
      icon: 'before:content-icon-retail-retail',
      url: '/retail-pos'
    }
  ],
  subMenus: [
    {
      label: 'Retail',
      showLabelMobile: false,
      subMenuEntryType: 'links',
      subMenuEntries: [
        {
          label: 'Convenience',
          icon: 'before:content-icon-retail-convenience',
          url: '/retail-pos/convenience-store',
          heapClass: 'nav_conven_v'
        },
        {
          label: 'Liquor Store',
          icon: 'before:content-icon-retail-bottle-shop',
          url: '/retail-pos/liquor-store',
          heapClass: 'nav_bottle/liq_v'
        },
        {
          label: 'Grocery',
          icon: 'before:content-icon-retail-grocery',
          url: '/retail-pos/grocery-store',
          heapClass: 'nav_grocery_v'
        },
        {
          label: 'Butcher',
          icon: 'before:content-icon-retail-butcher-shop',
          url: '/retail-pos/butcher-shop',
          heapClass: 'nav_butchershop_v'
        },
        {
          label: 'Restaurant/Retail Hybrid',
          icon: 'before:content-icon-retail-restaurant-retail-hybrid',
          url: '/restaurant-pos/hybrid-restaurant',
          heapClass: 'nav_retailhybrid_v'
        }
      ]
    }
  ]
}

export default Retail
